var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exceptionPage"},[_c('div',{staticClass:"imgEle"}),_c('div',{staticClass:"exceptionTip"},[_c('h1',{staticClass:"exceptionText"},[_vm._v("403")]),_c('div',{staticClass:"exceptionDesc"},[_vm._v("抱歉，你无权访问该页面")]),_c('Button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回首页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }